module.exports = __webpack_public_path__ + "static/img/d-4.c3ace3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/d-4.png
// module id = XYqs
// module chunks = 1